import React from 'react';

import cx from 'classnames';

import Text from 'components/shared/Typography/Text';

import s from './index.module.css';

function Title({ text, withBorder }: { text: string; withBorder?: boolean }) {
  const [title, subtitle] = text.split('\n');
  return (
    <div className={cx(s.header, withBorder && s.withBorder)}>
      <Text className={s.title} accent>
        {title}
      </Text>
      {subtitle && (
        <Text className={s.title} accent>
          {subtitle}
        </Text>
      )}
    </div>
  );
}

export default Title;
